import {
    GET_ALL_CACHING,
    GET_ALL_CACHING_ERROR,
    GET_ALL_CACHING_SUCCESS,
    REMOVE_CACHE,
    REMOVE_CACHE_ERROR,
    REMOVE_CACHE_RESET,
    REMOVE_CACHE_SUCCESS
} from "../actions/administratorAction"

const initialState = {
    cachingData: [],
    cachingDeleteData: [],
    loading: false,
    deleting: false,
    error: null,
}

export default function brandReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_CACHING:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case GET_ALL_CACHING_SUCCESS:
            return {
                ...state,
                loading: false,
                cachingData: action.payload.success,
            }

        case GET_ALL_CACHING_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                cachingData: [],
            }

        case REMOVE_CACHE:
            return {
                ...state,
                deleting: true,
                error: null,
            }

        case REMOVE_CACHE_SUCCESS:
            return {
                ...state,
                deleting: false,
                cachingDeleteData: action.payload.success,
            }

        case REMOVE_CACHE_ERROR:
            return {
                ...state,
                deleting: false,
                error: action.payload.error,
                cachingDeleteData: [],
            }

        case REMOVE_CACHE_RESET:
            return {
                ...state,
                deleting: false,
                error: null,
                cachingDeleteData: {},
            };

        default:
            return state
    }
}